import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';
import {CommonUtilitiesService} from '../common-utilities.service'
@Injectable({
  providedIn: 'root'
})
export class ActivationPassportService {
  constructor(private serviceCallUtilsService: ServiceCallUtilsService,private commonUtilitiesService:CommonUtilitiesService) { }

  /**
   * Description: Método que llama el servicio web de enviar código de validación
   * Autor: Diego Diaz
   * @param phone teléfono al cual se enviará el pin de portabilida
   * @return N/A
   */
  sendSMSCode(phone){
    //url de ejemplo, cambiar por endpoint del servicio
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_PORTABILITY_SEND_VALIDATION_CODE_SMS, { "identificationValue": phone });
  }

  /**
   * Description: Método que llama el servicio web de validar el codigo y la cédula del paso 1 de portabilidad
   * Autor: Diego Diaz
   * @param phone teléfono al cual se enviará el pin de portabilida
   * @param pin pin enviado por sms
   * @return N/A
   */
  validateSMSCodeAndDocument(phone, pin){
    //url de ejemplo, cambiar por endpoint del servicio
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_PORTABILITY_VALIDATE_CODE_SMS, { "msisdn": phone, "pin": pin });
  }

  /**
   * Description: Método que llama el servicio web que retorna la información de registro civil
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getInfoByDocument(documentType, documentId){
    //url de ejemplo, cambiar por endpoint del servicio
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_USER_INFO_FROM_STATE_AGENCY_BY_DOCUMENT, { "identificationType": documentType, "identificationNumber": documentId });
  }

  /**
   * Description: Método que llama el servicio web que hace la solicitud de portabilidad
   * Autor: Diego Diaz
   * @param dataJson todos los datos del formulario de portabilidad
   * @return confirmación de creación de ticket o envio de email portabilidad 
   */
  sendPortabilityRequest(dataJson){
    //url de ejemplo, cambiar por endpoint del servicio
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_PORTABILITY_REQUEST, dataJson);
  }

  /**
   * Description: Método que llama el servicio web de validar ICC
   * Autor: Diego Diaz
   * @param valueICC ICCID del chip
   * @return Mensaje de confirmación de la validación
   */
  validateICC(valueICC, isPreActivatedChip = true) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_VALIDATE_ICC+constants.PARAMETER_ENDPOINT_VALIDATE_ICC+isPreActivatedChip, { "valueICC": valueICC });
  }

   /**
   * Description: Método que llama el servicio web de obtener ciudades y provincias
   * Autor: Diego Diaz
   * @param N/A
   * @return listado de ciudades y provincias
   */
  getCityProvinceList() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_PORTABILITY_GET_CITIES, "");
  }
  
  /**
   * Description: Método que llama el servicio web de obtener el documento de descarga del formato de portabildiad
   * Autor: Diego Diaz
   * @param N/A
   * @return listado de ciudades y provincias
   */
  getDocumentFormat() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_PORTABILITY_GET_DOCUMENT_FORMAT, {"category": constants.CATEGORY_PORTABILIDAD});
  }
  
    /**
   * Description: Método que llama el servicio web de validar el IMEI
   * Autor: Diego Diaz
   * @param imei numero de imei del movil
   * @return Confirmación de la validación
   */
  validateIMEI(imei) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_VALIDATE_IMEI, {"identificationValue": imei});
  }
}
